const playBtn = document.querySelector(".post-section.section-video-block .play")
const overlay = document.querySelector(".post-section.section-video-block .overlay")
const video = document.querySelector(".post-section.section-video-block video")

if (video) {
    playBtn.addEventListener("click", () => {
        video.setAttribute("controls", "controls")
        playVideo()
    })

    async function playVideo() {
        try {
            await video.play();
            playBtn.classList.add("hidden")
            overlay.classList.add("hidden")
        } catch (err) {
            console.log(err);
        }
    }

}